export function LocalShippingIcon({ className }: { className?: string }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.6668 6.66671H14.1668V3.33337H2.50016C1.5835 3.33337 0.833496 4.08337 0.833496 5.00004V14.1667H2.50016C2.50016 15.55 3.61683 16.6667 5.00016 16.6667C6.3835 16.6667 7.50016 15.55 7.50016 14.1667H12.5002C12.5002 15.55 13.6168 16.6667 15.0002 16.6667C16.3835 16.6667 17.5002 15.55 17.5002 14.1667H19.1668V10L16.6668 6.66671ZM16.2502 7.91671L17.8835 10H14.1668V7.91671H16.2502ZM5.00016 15C4.54183 15 4.16683 14.625 4.16683 14.1667C4.16683 13.7084 4.54183 13.3334 5.00016 13.3334C5.4585 13.3334 5.8335 13.7084 5.8335 14.1667C5.8335 14.625 5.4585 15 5.00016 15ZM6.85016 12.5C6.39183 11.9917 5.74183 11.6667 5.00016 11.6667C4.2585 11.6667 3.6085 11.9917 3.15016 12.5H2.50016V5.00004H12.5002V12.5H6.85016ZM15.0002 15C14.5418 15 14.1668 14.625 14.1668 14.1667C14.1668 13.7084 14.5418 13.3334 15.0002 13.3334C15.4585 13.3334 15.8335 13.7084 15.8335 14.1667C15.8335 14.625 15.4585 15 15.0002 15Z"
        fill="currentColor"
      />
    </svg>
  )
}
